<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Configure Square Customer Groups</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <h3 *ngIf="loadingSquareCustomerGroups" class="text-secondary">Loading groups...</h3>

    <ng-container *ngIf="!loadingSquareCustomerGroups">
      <label>Select which Square customer groups will be managed by Capitan:</label>

      <div class="alert alert-info">
        These groups will be available for selection when configuring memberships and associations. Capitan will never add or remove customers from Square customer groups which are not managed by Capitan.
      </div>

      <div class="form-group">
        <span *ngIf="squareCustomerGroupList.length === 0" class="text-muted">No customer groups configured in Square</span>
        <ng-container *ngIf="squareCustomerGroupList.length > 0">
          <div *ngFor="let scg of squareCustomerGroupList" class="form-check">
            <input class="form-check-input" type="checkbox"
                   id="scgInput{{ scg.id }}" name="scgInput{{ scg.id }}"
                   [(ngModel)]="scg.is_managed_by_capitan">
            <label class="form-check-label" for="scgInput{{ scg.id }}">{{ scg.name }}</label>
          </div>
        </ng-container>
      </div>

      <div class="alert alert-warning">
        If a group is unselected from this list, it will be removed from any assigned memberships and associations, and any customers which have automatically be added to the group by Capitan will remain in the group indefinitely.
      </div>
    </ng-container>

    <div class="alert alert-danger" *ngIf="errorMessage !== ''">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary"
            (click)="handleSubmit()"
            *ngIf="!loadingSave">
      Save
    </button>
    <button class="btn btn-primary disabled" type="button" disabled
            *ngIf="loadingSave">
      Loading...
    </button>
  </div>

</ng-container>
